/**
 * Private modules
 */
const {
  customerId,
  objectId,
  percent,
  rootId,
} = require('../.private').components;

module.exports = {
  updateCustomerRunnerTicketHookEntriesByRootId: {
    properties: {
      body: {
        properties: {
          entries: {
            items: {
              properties: {
                objectId,
                percent,
              },
              required: [
                'objectId',
                'percent',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['entries'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          rootId,
        },
        required: [
          'customerId',
          'rootId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
